import React from "react";
import Container from "react-bootstrap/Container";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FOOTER_CONTACT, NAV_SERVICES } from "data/navigation";
import { PATHS } from "data/paths";

export default function Footer() {
  return (
    <footer>
      <Container>
        <Row>
          <Col
            lg="2"
            md="2"
            sm="12"
            className="wow fadeInUp span12 offcanlink"
            data-wow-duration="0.5s"
          >
            <img
              src="images/05993dfa7132ab1ad50099b06767aa50_1200_80.webp"
              alt="logo"
            />
          </Col>
          <Col
            lg="3"
            md="3"
            sm="12"
            className="wow fadeInUp servicesFooter"
            data-wow-duration="0.5s"
          >
            <h5>Services</h5>
            <div>
              {NAV_SERVICES.map((service) => (
                <Link key={service.to} to={service.to}>
                  {service.label}{" "}
                </Link>
              ))}
            </div>
          </Col>
          <Col
            lg="5"
            md="5"
            sm="12"
            className="wow fadeInUp span12 emailFooter"
            data-wow-duration="0.5s"
          >
            <h5>EMAIL US</h5>
            <a href={`mailto:${FOOTER_CONTACT.email}`}>
              <p>{FOOTER_CONTACT.email} </p>
            </a>
            <p style={{ marginTop: "80px" }}>{FOOTER_CONTACT.address}</p>
          </Col>
          <Col
            lg="2"
            md="2"
            sm="12"
            className="wow fadeInUp span12 callFooter"
            data-wow-duration="0.5s"
          >
            <h5>CALL US</h5>
            <div>
              <a href={`tel:${FOOTER_CONTACT.salesPhone}`}>
                Sales Team:
                <br />
                <span>{FOOTER_CONTACT.salesPhone}</span>
              </a>
              <br />
              <a href={`tel:${FOOTER_CONTACT.supportPhone}`}>
                Support Team:
                <br />
                <span> {FOOTER_CONTACT.supportPhone}</span>
              </a>
            </div>
          </Col>
        </Row>
        <div className="iconsfooter wow fadeInUp ">
          {FOOTER_CONTACT.social.map((item) => (
            <a key={item.alt} href={item.href}>
              <img src={item.src} alt={item.alt} />
            </a>
          ))}
        </div>
        <div className="footerBorder">
          <div className="copyRight wow fadeInUp ">
            <p>Copyright © 2025 Extronnect LLC. All Rights Reserved.</p>
            <div>
              <Link to={PATHS.terms}>Terms and Conditions</Link>
              <Link to={PATHS.policy}>Privacy Policy</Link>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
}
